module.exports = __webpack_public_path__ + "img/g0012.edef5fb9.png";